export default __webpack_public_path__ + "static/aq-72a924ff408cbd8f1e24b1f634399f55.svg";